import {IColumn} from "@fluentui/react";
import strings from "../../../loc/strings";

export enum Tab {
    Natural = "natural",
    Legal = "legal"
}

export enum ColumnFieldName {
    ID = "id",
    FirstName = "firstName",
    LastName = "lastName",
    LegalName = "legalName",
    AlsoKnownAs = "alsoKnownAs",
    DateOfBirth = "dateOfBirth",
    PlaceOfBirth = "placeOfBirth",
    IDNumber = "idNumber",
    LeiRegistration = "leiRegistration",
    CountryOfIncorporation = "countryOfIncorporation",
    SocialSecurityNumber = "socialSecurityNumber",
    Actions = "actions",
}

export const _naturalColumns: IColumn[] = [
    {
        key: "column0",
        name: strings.columnNameID,
        fieldName: ColumnFieldName.ID,
        minWidth: 50,
        maxWidth: 50
    },
    {
        key: "column1",
        name: strings.columnNameFirstName,
        fieldName: ColumnFieldName.FirstName,
        minWidth: 150,
        maxWidth: 200,
        isResizable: true
    },
    {
        key: "column2",
        name: strings.columnNameLastName,
        fieldName: ColumnFieldName.LastName,
        minWidth: 150,
        maxWidth: 200,
        isResizable: true
    },
    {
        key: "column3",
        name: strings.columnNameAKA,
        fieldName: ColumnFieldName.AlsoKnownAs,
        minWidth: 150,
        maxWidth: 200,
        isResizable: true
    },
    {
        key: "column4",
        name: strings.columnNameDOB,
        fieldName: ColumnFieldName.DateOfBirth,
        minWidth: 150,
        maxWidth: 200,
        isResizable: true
    },
    {
        key: "column5",
        name: strings.columnNamePOB,
        fieldName: ColumnFieldName.PlaceOfBirth,
        minWidth: 150,
        maxWidth: 200,
        isResizable: true
    },
    {
        key: "column6",
        name: strings.columnNameIDNumber,
        fieldName: ColumnFieldName.IDNumber,
        minWidth: 150,
        maxWidth: 200,
        isResizable: true
    },
    {
        key: "column7",
        name: strings.columnNameSSN,
        fieldName: ColumnFieldName.SocialSecurityNumber,
        minWidth: 150,
        isResizable: true
    },
    {
        key: "column8",
        name: strings.columnNameActions,
        fieldName: ColumnFieldName.Actions,
        minWidth: 50,
        maxWidth: 80,
        isResizable: true
    },
];

export const _legalColumns: IColumn[] = [
    {
        key: "column0",
        name: strings.columnNameID,
        fieldName: ColumnFieldName.ID,
        minWidth: 50,
        maxWidth: 50
    },
    {
        key: "column1",
        name: strings.columnNameLegalName,
        fieldName: ColumnFieldName.LegalName,
        minWidth: 150,
        maxWidth: 200,
        isResizable: true
    },
    {
        key: "column2",
        name: strings.columnNameAKA,
        fieldName: ColumnFieldName.AlsoKnownAs,
        minWidth: 150,
        maxWidth: 200,
        isResizable: true
    },
    {
        key: "column3",
        name: strings.columnNameLeiRegistration,
        fieldName: ColumnFieldName.LeiRegistration,
        minWidth: 150,
        maxWidth: 200,
        isResizable: true
    },
    {
        key: "column4",
        name: strings.columnNameCountryInc,
        fieldName: ColumnFieldName.CountryOfIncorporation,
        minWidth: 200,
        isResizable: true
    },
    {
        key: "column5",
        name: strings.columnNameActions,
        fieldName: ColumnFieldName.Actions,
        minWidth: 50,
        maxWidth: 80,
        isResizable: true
    },
];